<p-menubar [model]="items" styleClass="">
  <ng-template pTemplate="start">

    <img
      src="../../../../assets/img/site-icon.svg"
      alt="Bizpay"
      height="40"
      class="mx-2"
      (click)="openHomePage()"
    />
  </ng-template>
</p-menubar>
<div class="px-3">
    <div class="m-4">
        <router-outlet></router-outlet>

    </div>
</div>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>

<p-dialog
  [showHeader]="false"
  [(visible)]="session_expired"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
  styleClass="br-4"
>
  <div class="text-center m-5">
    <h4 class="mb-4">Session expired due to inactivity.</h4>
    <button
      pButton
      pRipple
      type="button"
      label="Re-Login"
      class="p-button-raised text-center"
      (click)="onLogout()"
    ></button>
  </div>
</p-dialog>
